export default {"src":"/_next/static/media/seed_legals_logo.bc2f1c57.svg","height":29,"width":270,"blurWidth":0,"blurHeight":0};